import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { SertMqttDto } from '../../dto/SertMqttDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeleteSertMqtt = async (dto: SertMqttDto) => {
  const params: IApiParams = {
    url: '/sert-mqtt/deleteSert.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
